import { Injectable } from "@angular/core";
import confetti from "canvas-confetti";

@Injectable({
    providedIn: "root",
})
export class ConfettiService {
    public snowIsFalling: boolean;

    constructor() {}

    randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }

    toggleSnow() {
        if (this.snowIsFalling) return (this.snowIsFalling = false);

        this.snowIsFalling = true;
        const _ = this;
        const duration = 15 * 1000;
        const animationEnd = Date.now() + duration;

        (function frame() {
            const timeLeft = animationEnd - Date.now();
            const ticks = Math.max(200, 500 * (timeLeft / duration));
            let skew = 1;
            skew = Math.max(0.8, skew - 0.001);

            confetti({
                particleCount: 1,
                startVelocity: 0,
                ticks: ticks,
                origin: {
                    x: Math.random(),
                    // since particles fall down, skew start toward the top
                    y: Math.random() * skew - 0.2,
                },
                colors: ["#ffffff"],
                shapes: ["circle"],
                gravity: _.randomInRange(0.4, 0.6),
                scalar: _.randomInRange(0.4, 1),
                drift: _.randomInRange(-0.4, 0.4),
            });
            if (_.snowIsFalling) {
                requestAnimationFrame(frame);
            }
        })();
    }
}
